import { Box, Tooltip } from '@mui/material';

interface ClaimOwnerToolTipProps {
  dateData: {
    hoverData?: {
      taskId: string;
      status: string;
    }[];
    info?: string;
  };
  isToday?: boolean;
}
export function ClaimOwnerToolTip({
  dateData,
  isToday,
}: ClaimOwnerToolTipProps) {
  const groupedHoverData = dateData.hoverData?.reduce<Record<string, string[]>>(
    (acc, item) => {
      if (!acc[item.status]) {
        acc[item.status] = [];
      }

      acc[item.status].push(item.taskId);
      return acc;
    },
    {}
  );

  const hoverDataComponent = (hoverData?: Record<string, string[]>) => {
    return Object.entries(hoverData || []).map(([status, taskIds]) => (
      <Box key={status}>
        <strong>{status}:</strong> {taskIds.join(', ')}
      </Box>
    ));
  };

  return (
    <Tooltip title={hoverDataComponent(groupedHoverData)}>
      <Box sx={isToday ? { fontWeight: 'bold', color: 'primary.main' } : {}}>
        {dateData.info}
      </Box>
    </Tooltip>
  );
}
